import { Flex, Text } from "@mantine/core";
import { useLocation, useNavigate } from "react-router";
import DataTable, { Column } from "../../common/Table/DataTable";
import TableDeleteButton from "../../common/Buttons/TableDeleteButton";
import TableEditButton from "../../common/Buttons/TableEditButton";
import { useTableQuery } from "../../../hooks/useTableQuery";
import { useDeleteWithConfirm } from "../../../hooks/useDeleteWithConfirm";
import { deleteContract, getContractList } from "../../../api/contractApi";
import { formatDateDayMonthYear } from "../../../utils/dateFormats";

const ContractSettingsTable = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const table = useTableQuery({ fetcher: getContractList });

  const { askDelete, modal } = useDeleteWithConfirm({
    deleteFn: deleteContract,
    onDeleted: table.refetch,
    title: "Kontratı Sil",
    text: "Bu kontratı silmek istediğinizden emin misiniz?",
  });

  const columns: Column[] = [
    {
      key: "name",
      header: "Kontrat İsmi",
      width: "25%",
      render: (row) => (
        <Text fw={400} size="md" truncate="end">
          {row?.name}
        </Text>
      ),
    },
    {
      key: "monthlyHours",
      header: "Çalışma Süresi (Ay)",
      width: "20%",
      render: (row) => (
        <Text size="md" fw={400}>
          {row?.monthlyHours} Saat
        </Text>
      ),
    },
    {
      key: "startDate",
      header: "Başlangıç Tarihi",
      width: "20%",
      render: (row) => (
        <Text size="md" fw={400}>
          {row?.startDate ? formatDateDayMonthYear(row.startDate) : "—"}
        </Text>
      ),
    },
    {
      key: "endDate",
      header: "Bitiş Tarihi",
      width: "20%",
      render: (row) => (
        <Text size="md" fw={400}>
          {row?.endDate ? formatDateDayMonthYear(row.endDate) : "—"}
        </Text>
      ),
    },
    {
      key: "actions",
      header: "İşlemler",
      width: "15%",
      render: (row) => (
        <Flex gap={6} justify="start">
          <TableEditButton
            onClick={(e: any) => {
              e.stopPropagation();
              navigate(`${location.pathname}/${row._id}/update`);
            }}
          />
          <TableDeleteButton
            onClick={(e: any) => {
              e.stopPropagation();
              askDelete(row);
            }}
          />
        </Flex>
      ),
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        rows={table.rows}
        loading={table.loading}
        emptyText="Henüz kontrat kaydı yok."
        searchValue={table.search}
        onSearchChange={table.setSearch}
        searchPlaceholder="Kontrat ara..."
        page={table.page}
        totalPages={table.totalPages}
        onPageChange={table.setPage}
        limit={table.limit}
        onLimitChange={table.setLimit}
      />
      {modal}
    </>
  );
};

export default ContractSettingsTable;
